<script setup lang="ts">
import type { SlugHeaderContentProps } from './content';

defineProps<SlugHeaderContentProps>();
</script>

<template>
  <header class="pt-20 sm:pt-24 lg:pt-[calc(112px+var(--spacing-r18))]">
    <SlugHeaderContent :title :subtitle :description :image-header :links :icon />
  </header>
</template>
